import React, { useEffect, useState } from "react";
import { AdminHeader } from "../../components/AdminLayout";
import { api } from "../../lib/api";
import AdminPackages from "./AdminPackages";
import AdminCodes from "./AdminCodes";

const CODE_FILTERS = [
  { key: "all", label: "All" },
  { key: "promotion", label: "Promotion" },
  { key: "special", label: "Special" },
];

export default function AdminCatalog() {
  const [tab, setTab] = useState("packages");
  const [pkgFilter, setPkgFilter] = useState("all");
  const [codeFilter, setCodeFilter] = useState("all");
  const [groups, setGroups] = useState([]);
  useEffect(() => { api.get("/admin/pkg-config").then((r) => setGroups(r.data.groups || [])).catch(() => {}); }, []);
  useEffect(() => { if (pkgFilter !== "all" && groups.length && !groups.some((g) => g.key === pkgFilter)) setPkgFilter("all"); }, [groups, pkgFilter]);

  const pkgFilters = [{ key: "all", label: "All" }, ...groups.map((g) => ({ key: g.key, label: g.label }))];
  const subs = tab === "packages" ? pkgFilters : CODE_FILTERS;
  const active = tab === "packages" ? pkgFilter : codeFilter;
  const setActive = tab === "packages" ? setPkgFilter : setCodeFilter;

  return (
    <div>
      <AdminHeader title="Packages / Codes" subtitle="Buyable packages and promo / special codes in one place" />

      <div className="flex gap-2 mb-4" data-testid="catalog-tabs">
        {[{ k: "packages", l: "Packages" }, { k: "codes", l: "Codes" }].map((t) => (
          <button key={t.k} onClick={() => setTab(t.k)} data-testid={`catalog-tab-${t.k}`}
            className={`flex-1 sm:flex-none px-6 py-2.5 rounded-full text-sm font-semibold border transition-colors ${tab === t.k ? "bg-[#D4AF37] text-black border-transparent" : "bg-white/5 border-white/10 text-[#A19DB0]"}`}>{t.l}</button>
        ))}
      </div>

      <div className="flex gap-2 flex-wrap mb-6" data-testid="catalog-subfilters">
        {subs.map((f) => (
          <button key={f.key} onClick={() => setActive(f.key)} data-testid={`catalog-filter-${f.key}`}
            className={`px-3.5 py-1.5 rounded-full text-sm font-medium border transition-colors ${active === f.key ? "bg-white/15 text-white border-white/25" : "bg-white/5 border-white/10 text-[#A19DB0]"}`}>{f.label}</button>
        ))}
      </div>

      {tab === "packages"
        ? <AdminPackages embedded groupFilter={pkgFilter} />
        : <AdminCodes embedded kindFilter={codeFilter} />}
    </div>
  );
}
